/**
 * Mega Menu — Hover open/close + View All toggle
 * Breitvacher Header
 * Pattern: Dalvyn architecture — listen on <details> directly,
 *          open/close immediately on mouseover/mouseleave, no timeout.
 */

/* =============================================
   1. HOVER TO OPEN/CLOSE MEGA MENUS
   ============================================= */
(function () {
  function initMegaMenuHover() {
    var detailsEls = document.querySelectorAll('details.mega-menu');

    function enforceSolidHeaderWhenTransparencyDisabled() {
      var header = document.getElementById('site-header');
      if (!header || header.dataset.transparentHeader === 'true') return;

      header.classList.remove('site-header-transparent', 'site-header-hovered');
      var headerWrapper = header.closest('.header-wrapper');
      if (headerWrapper) {
        headerWrapper.classList.remove('header-wrapper--transparent', 'header-wrapper--hovered');
      }

      var logo = document.querySelector('.logo');
      var logoLight = document.querySelector('.logo-light');
      if (logo) {
        logo.style.opacity = 1;
        logo.style.visibility = 'visible';
        logo.style.display = 'block';
      }
      if (logoLight) {
        logoLight.style.opacity = 0;
        logoLight.style.visibility = 'hidden';
        logoLight.style.display = 'none';
      }
    }

    enforceSolidHeaderWhenTransparencyDisabled();
    if (!detailsEls || detailsEls.length === 0) return false;

    var closeTimers = new Map();

    function clearTimer(detail) {
      if (closeTimers.has(detail)) {
        clearTimeout(closeTimers.get(detail));
        closeTimers.delete(detail);
      }
    }

    function openDetail(detail) {
      clearTimer(detail);
      detail.classList.remove('is-closing');

      /* Close any other open mega menus first */
      detailsEls.forEach(function (other) {
        if (other !== detail && other.hasAttribute('open')) {
          clearTimer(other);
          other.removeAttribute('open');
          other.classList.remove('is-closing');
          var otherSummary = other.querySelector('summary');
          if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
        }
      });

      if (!detail.hasAttribute('open')) {
        detail.setAttribute('open', '');
        var summary = detail.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    }

    function scheduleClose(detail) {
      clearTimer(detail);
      detail.classList.add('is-closing');

      var timer = setTimeout(function () {
        if (detail.classList.contains('is-closing')) {
          detail.removeAttribute('open');
          detail.classList.remove('is-closing');
          var summary = detail.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');

          /* When mega menu closes and cursor is not hovering header, restore transparent state */
          var header = document.getElementById('site-header');
          enforceSolidHeaderWhenTransparencyDisabled();
          if (header && window.pageYOffset <= header.offsetHeight && !header.matches(':hover')) {
            var hw = header.closest('.header-wrapper');
            if (!hw || !hw.matches(':hover')) {
              var sideMenu = document.getElementById('Details-menu-drawer-container');
              var mobileDrawerOpen = (sideMenu && (sideMenu.classList.contains('menu-opening') || sideMenu.hasAttribute('open'))) ||
                                     document.body.classList.contains('menu-open') ||
                                     document.body.classList.contains('menu-opening');
              var hasOpen = Boolean(header.querySelector('details.mega-menu[open]:not(.is-closing)')) ||
                            mobileDrawerOpen ||
                            Boolean(header.querySelector('.header__search details[open]'));
              if (!hasOpen && header.dataset.transparentHeader === 'true') {
                header.classList.add('site-header-transparent');
                header.classList.remove('site-header-hovered');
                if (hw) {
                  hw.classList.remove('header-wrapper--hovered');
                  hw.classList.add('header-wrapper--transparent');
                }
                var logo = document.querySelector('.logo');
                var logoLight = document.querySelector('.logo-light');
                if (logo) logo.style.opacity = 0;
                if (logoLight) logoLight.style.opacity = 1;
              }
            }
          }
        }
        closeTimers.delete(detail);
      }, 250);

      closeTimers.set(detail, timer);
    }

    detailsEls.forEach(function (detail) {
      var summary = detail.querySelector('summary');
      var content = detail.querySelector('.mega-menu__content');
      var headerMenu = detail.closest('header-menu') || detail;

      /* Keep click navigation functional without collapsing dropdown mid-click */
      summary && summary.addEventListener('click', function (e) {
        // Toggle is controlled by hover/focus, summary link handles navigation
      });

      /* Enter header item or details -> open */
      headerMenu.addEventListener('mouseenter', function () {
        openDetail(detail);
      });

      detail.addEventListener('mouseenter', function () {
        openDetail(detail);
      });

      /* Leave header item -> schedule close with grace period */
      headerMenu.addEventListener('mouseleave', function () {
        if (detail.hasAttribute('open')) {
          scheduleClose(detail);
        }
      });

      /* Content hover maintains open state */
      if (content) {
        content.addEventListener('mouseenter', function () {
          openDetail(detail);
        });
      }

      /* Keyboard / Accessibility */
      detail.addEventListener('focusin', function () {
        openDetail(detail);
      });

      detail.addEventListener('focusout', function () {
        setTimeout(function () {
          if (detail.hasAttribute('open') && !detail.matches(':focus-within')) {
            detail.removeAttribute('open');
            detail.classList.remove('is-closing');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }
        }, 100);
      });
    });

    return true;
  }

  /* Run immediately if DOM is ready, otherwise wait */
  if (document.readyState !== 'loading') {
    initMegaMenuHover();
  } else {
    document.addEventListener('DOMContentLoaded', initMegaMenuHover);
  }
})();


/* =============================================
   2. VIEW ALL — Expand/collapse hidden items
   ============================================= */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-mm-viewall-toggle]');
  if (!btn) return;

  var column = btn.closest('.mm-panel__column');
  if (!column) return;

  var hiddenItems = column.querySelectorAll('.mm-panel__link-item--hidden');
  var textEl = btn.querySelector('.mm-panel__view-all-text');
  var isExpanded = btn.getAttribute('aria-expanded') === 'true';

  if (isExpanded) {
    hiddenItems.forEach(function (item) { item.classList.remove('is-visible'); });
    btn.setAttribute('aria-expanded', 'false');
    if (textEl) textEl.textContent = textEl.dataset.textMore || 'View All +';
  } else {
    hiddenItems.forEach(function (item, i) {
      setTimeout(function () { item.classList.add('is-visible'); }, i * 50);
    });
    btn.setAttribute('aria-expanded', 'true');
    if (textEl) textEl.textContent = textEl.dataset.textLess || 'Show Less −';
  }
});


/**
 * Dynamic mega-menu panels.
 * Brands and Best Sellers swap product-card templates into one live carousel
 * through the same data contract.
 */
(function () {
  function initDynamicMegaMenu(root) {
    if (root.dataset.dynamicMenuInitialized === 'true') return;

    var triggers = Array.from(root.querySelectorAll('[data-panel-trigger]'));
    var templates = Array.from(root.querySelectorAll('template[data-panel-template]'));
    var panel = root.querySelector('[data-dynamic-panel]');
    var title = root.querySelector('[data-panel-title]');
    var description = root.querySelector('[data-panel-description]');
    var viewLink = root.querySelector('[data-panel-view-link]');
    var viewLabel = root.querySelector('[data-panel-view-label]');
    var carousel = root.querySelector('[data-panel-carousel] [data-mm-carousel]');
    var track = carousel && carousel.querySelector('[data-track]');

    if (!triggers.length || !templates.length || !panel || !track) return;
    root.dataset.dynamicMenuInitialized = 'true';

    var panelTimeout;

    function activatePanel(key, force) {
      if (!key || (!force && root.dataset.activePanel === key)) return;

      var template = templates.find(function (item) {
        return item.dataset.panelTemplate === key;
      });
      if (!template) return;

      var source = template.content.querySelector('[data-panel-items]');
      if (!source) return;

      if (force) {
        executeSwap();
      } else {
        panel.classList.add('is-transitioning');
        if (panelTimeout) clearTimeout(panelTimeout);
        panelTimeout = setTimeout(executeSwap, 150);
      }

      function executeSwap() {
        panel.setAttribute('aria-busy', 'true');
        track.replaceChildren.apply(
          track,
          Array.from(source.children).map(function (item) {
            return item.cloneNode(true);
          })
        );

        if (title) title.textContent = template.dataset.panelTitle || '';
        if (description) {
          description.textContent = template.dataset.panelDescription || '';
          description.hidden = !template.dataset.panelDescription;
        }
        if (viewLink) viewLink.href = template.dataset.panelUrl || '#';
        if (viewLabel) viewLabel.textContent = template.dataset.panelViewLabel || '';

        triggers.forEach(function (trigger) {
          var isActive = trigger.dataset.panelKey === key;
          trigger.classList.toggle('mm-panel__link--active', isActive);
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        root.dataset.activePanel = key;
        carousel.dispatchEvent(new CustomEvent('mm-carousel:refresh'));
        panel.setAttribute('aria-busy', 'false');

        if (!force) {
          requestAnimationFrame(function () {
            panel.classList.remove('is-transitioning');
          });
        }
      }
    }

    triggers.forEach(function (trigger) {
      var activate = function () {
        activatePanel(trigger.dataset.panelKey, false);
      };
      trigger.addEventListener('mouseenter', activate);
      trigger.addEventListener('focus', activate);
    });

    var defaultTrigger = triggers.find(function (trigger) {
      return trigger.getAttribute('aria-current') === 'true';
    }) || triggers[0];
    activatePanel(defaultTrigger.dataset.panelKey, true);
  }

  function bootDynamicMegaMenus(scope) {
    var selector = '[data-dynamic-mega-menu="brands"], [data-dynamic-mega-menu="best-sellers"]';
    var roots = [];
    if (scope && scope.matches && scope.matches(selector)) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.from(scope.querySelectorAll(selector)));
    }
    roots.forEach(initDynamicMegaMenu);
  }

  if (document.readyState !== 'loading') bootDynamicMegaMenus(document);
  else document.addEventListener('DOMContentLoaded', function () { bootDynamicMegaMenus(document); });

  document.addEventListener('shopify:section:load', function (event) {
    bootDynamicMegaMenus(event.target);
  });
})();
